import { Divider } from "components/design/Divider";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { AddAsset } from "components/FixedAsset/AddAsset";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";
import { useModal } from "hooks/useModal";
import { useDispatch, useSelector } from "react-redux";
import { closeFixedAssetModal } from "store/slices/fixedAssetModal";
import { RootState } from "store/store";
import { DepreciationSchedulePreview } from "types/Models/fixedAsset";

export const FixedAssetConfirmationModal = () => {
  const dispatch = useDispatch();
  const addAssetModal = useModal();

  const { isOpen, transactionData } = useSelector(
    (state: RootState) => state.fixedAssetModal
  );

  const onClose = () => {
    dispatch(closeFixedAssetModal());
  };

  const handleAddFixedAsset = () => {
    dispatch(closeFixedAssetModal());
    addAssetModal.open();
  };

  const purchasePrice = Math.abs(transactionData?.amount || 0);

  const depreciationScheduleData: DepreciationSchedulePreview | undefined =
    transactionData
      ? {
          fixed_asset: {
            asset_name: "",
            description: transactionData.description || "",
            purchase_price: purchasePrice,
            depreciation_start_date: transactionData.date
              ? dayjs(transactionData.date).format(DISPLAY_DATE)
              : "",
            salvage_value: 0,
            useful_life: 0,
            current_value: purchasePrice,
            frequency: "MONTHLY",
            asset_account_id: "",
            depreciation_account_id: "",
            accumulated_depreciation_account_id: "",
            accumulated_depreciation_amount: 0,
          },
          depreciation_schedule: [],
        }
      : undefined;

  if (!isOpen && !addAssetModal.isOpen) {
    return null;
  }

  return (
    <>
      <Modal.Root open={isOpen} onOpenChange={onClose}>
        <Modal.Content size="small">
          <StatusModal
            type="success"
            title="Transaction is categorised as Fixed Assets"
          >
            <div className="t-text-body-sm t-space-y-3">
              <Divider classNames="t-mt-4" type="faded_solid" color="grey">
                <span className="t-text-body-sm-italic t-text-neutral-30 t-italic ">
                  Suggested next steps
                </span>
              </Divider>
              <div className=" t-text-text-30 t-text-body-sm">
                Since this is a Fixed Asset, would you like to add a Fixed Asset
                entry and create its depreciation schedule to automatically
                record monthly expenses and keep your books accurate?
              </div>
            </div>
          </StatusModal>
          <Modal.Footer className="t-flex t-justify-end t-gap-3">
            <Button onClick={onClose}>Do it later</Button>
            <Button customType="primary" onClick={handleAddFixedAsset}>
              Add Fixed Asset
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
      <AddAsset
        {...addAssetModal}
        depreciationScheduleData={depreciationScheduleData}
      />
    </>
  );
};
